/**
 * Trafik Kaynağı Attribution — first-touch SSoT
 * =============================================
 * UTM param'ları landing'de gelir (?utm_source=...), kullanıcı kayıt-ol formuna
 * giderken query kaybolur. Çözüm: ilk app yüklemesinde sessionStorage'a yaz
 * (first-touch — zaten varsa ÜZERİNE YAZMA), form submit'inde oku.
 *
 * Tek doğruluk kaynağı: bu dosya. Capture + read aynı yerden, inline duplicate yasak.
 */

const STORAGE_KEY = 'riskmatik.attribution';

export interface Attribution {
  referrer?: string;
  utmSource?: string;
  utmMedium?: string;
  utmCampaign?: string;
}

/**
 * İlk app yüklemesinde çağrılır (idempotent first-touch).
 * Zaten kayıt varsa hiçbir şey yapmaz — ilk dokunuş korunur, loop/overwrite yok.
 */
export function captureAttribution(): void {
  if (typeof window === 'undefined') return;
  try {
    if (window.sessionStorage.getItem(STORAGE_KEY)) return; // first-touch korunur

    const params = new URLSearchParams(window.location.search);
    const data: Attribution = {};

    const utmSource = params.get('utm_source');
    const utmMedium = params.get('utm_medium');
    const utmCampaign = params.get('utm_campaign');
    if (utmSource) data.utmSource = utmSource;
    if (utmMedium) data.utmMedium = utmMedium;
    if (utmCampaign) data.utmCampaign = utmCampaign;

    // document.referrer: dış siteden geliş (aynı origin ise atla — internal nav)
    const ref = document.referrer || '';
    if (ref && !ref.startsWith(window.location.origin)) {
      data.referrer = ref;
    }

    window.sessionStorage.setItem(STORAGE_KEY, JSON.stringify(data));
  } catch {
    /* sessionStorage erişilemezse sessiz geç — attribution best-effort */
  }
}

/**
 * Form submit'inde çağrılır — first-touch attribution'ı payload'a ekler.
 */
export function getAttribution(): Attribution {
  if (typeof window === 'undefined') return {};
  try {
    const raw = window.sessionStorage.getItem(STORAGE_KEY);
    if (!raw) return {};
    const parsed = JSON.parse(raw);
    return parsed && typeof parsed === 'object' ? (parsed as Attribution) : {};
  } catch {
    return {};
  }
}
